$shm_hitalama_map_widget_float_code_bench_result $mol_view
	sub /
		<= Copy $shm_button_copy
			button_sub / <= Copy_icon $mol_icon_content_copy
			text <= copy_text \
		<= Result_row $mol_scroll
			sub <= result_view /
				<= Error $mol_text
					text <= error_text \
					code_sidebar_showed false
				<= Result $mol_dump_value
					expanded? <=> expanded? true
					minimal_height 0
					value <= state null
				<= Result_table $mol_grid
					minimal_height 0
					records <= result_table_rows *
					col_ids <= result_table_col_ids /
					col_head_content* <= col_head_content* /
